<template>
  <div id="inline">
    <el-link
      :underline="false"
      @click.native.prevent="dialogVisible = true"
    >
      Forward all Emails
    </el-link>
    <el-dialog
      title="Forward all emails"
      :visible.sync="dialogVisible"
      width="40%"
      :before-close="handleClose"
      append-to-body
      @opened="set_default_input(), forward_all_emails_read()"
    >
      <el-select
        ref="mailbox_select"
        v-model="current_selected"
        placeholder="Select mailbox"
        style="margin: -2px 6px 4px 0px;width: 380px;"
      >
        <el-option
          v-for="mailbox in mailboxes"
          :key="mailbox.value"
          size="mini"

          :label="mailbox.label"
          :value="mailbox.value"
        />
      </el-select>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          size="mini"
          @click="dialogVisible = false"
        >Cancel</el-button>
        <el-button
          size="mini"
          type="danger"
          @click="remove_forward(), dialogVisible = false"
        >Remove forward</el-button>
        <el-button
          size="mini"
          type="primary"
          @click="forward_all_emails_write(),dialogVisible = false"
        >Save</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'ForwardAllEmails',
  props: {
    mailbox_id: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      dialogVisible: false,
      mailboxes:[],
      current_selected: ''
    };
  },
  created(){
    this.get_shared_mailboxes();
  },
  methods: {
    get_shared_mailboxes() {
      this.$http
        .post('/get_shared_mailboxes')
        .then(
          response => {
            this.mailboxes = response.data.mailboxes;
          }
        );
    },
    forward_all_emails_read() {
      this.$http.post('/forward_all_emails_read', {mailbox_account_id: this.mailbox_id}).then(
        response => {this.current_selected = response.data.current_mailbox_id;});
    },
    forward_all_emails_write() {
      this.$http.post('/forward_all_emails_write', {
        mailbox_account_id: this.current_selected,
        mailbox_id: this.mailbox_id
      }).then(
        response => {
          this.$message({
            message: `Forward set from ${response.data.from} to ${response.data.to}`,
            type: 'success',
            duration: 5000
          });
        },
        response => {
          this.$message({
            message: response.data.errors,
            type: 'error'
          });
        }
      );
    },
    remove_forward() {
      this.$http.post('/forward_all_emails_remove', {
        mailbox_id: this.mailbox_id
      }).then(
        response => {
          this.$message({
            message: `Forward removed for ${response.data.from}`,
            type: 'success',
            duration: 5000
          });
          this.current_selected = '';
        },
        error => {
          this.$message({
            message: error.response?.data?.error || 'Failed to remove forward',
            type: 'error'
          });
        }
      );
    },
    handleClose(done) {
      done();
    },
    set_default_input() {
      Array.from(document.querySelectorAll('.el-select__input, .el-input__inner')).forEach(
        function (e) {
          e.classList.add('browser-default');
          if (e.querySelector('input') != null)
            e.querySelector('input').className += ' browser-default';
        }
      );
    },
  },
};
</script>

<style scoped>
#inline {
  display: inline;
}
.space { margin-bottom: 10px;}
</style>
